const MIDDLE_MOBILE_WIDTH = 500;
const MAX_MOBILE_WIDTH = 768;
const MAX_TABLET_WIDTH = 1024;

export default {
  data() {
    return {
      width: 0
    };
  },
  watch: {
    width(newWidth, oldWidth) {
      this.width = newWidth;
    }
  },
  computed: {
    isMobileSM() {
      return this.width < MIDDLE_MOBILE_WIDTH;
    },
    isMobile() {
      return this.width < MAX_MOBILE_WIDTH;
    },
    isTablet() {
      return this.width < MAX_TABLET_WIDTH && this.width > MAX_MOBILE_WIDTH;
    },
    isDesktop() {
      return this.width > MAX_TABLET_WIDTH;
    }
  },
  mounted() {
    this.width = window.innerWidth;
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.width = window.innerWidth;
      });
    });
  }
};
